import { tabsCaptionStrongSx, tabsCaptionSx } from '../../../styles/commonStyles';
import DraggableVocabulary from './draggableVocabulary';
import { styled } from '@mui/material/styles';
import { Colors } from 'copyright-clearance-center-common-ui';

const ColoredDraggableVocabulary = styled(DraggableVocabulary)(props => ({
	backgroundColor: props.palette.hover,
	display: 'flex',
	flexDirection: 'row',
	padding: '0.5rem',
	columnGap: '0.25rem',
	justifyContent: 'space-between',
	color: Colors.neutral900,
	borderRadius: '0.25rem',
	'&:active': {
		backgroundColor: `${props.palette.selectedBar} !important`,
		color: '#FFFFFF !important'
	},
	'&:hover': {
		backgroundColor: props.palette.unselectedBar
	},
	'& .title': {
		flexGrow: 1,
		...tabsCaptionStrongSx
	},
	'& .count': {
		...tabsCaptionSx
	},
	'& .rup-icon svg': {
		margin: 'auto',
		color: Colors.neutral600
	}
}));

export default ColoredDraggableVocabulary;
